import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SafehtmlPipe } from '../_pipes/safehtml.pipe';
import { CKEditorModule } from 'ng2-ckeditor';
import { ClipboardModule } from 'ngx-clipboard';


import { FormValidationMessageComponent } from '../_directives/form-validation-message/form-validation-message.component'
import { PaginationComponent } from '../_directives/pagination/pagination.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SearchByPipe } from '../_pipes/search-by.pipe';
import { PasswordValidator } from '../_directives/password-validator/password-validator.directive';
import { SortByPipe } from '../_pipes/sort-by.pipe';
import { KeysPipe } from '../_pipes/keys.pipe';
import { TimeAgoPipe } from '../_pipes/time-ago.pipe';
import { RoundPipe } from '../_pipes/round.pipe';
import { TextSelectDirective } from '../_directives/text-selector/text-select.directive';
import { DragAndDropDirective } from '../_directives/drag-and-drop/drag-and-drop.directive';
import { NotificationsComponent } from '../notifications/notifications.component';
import { ScrollbarModule } from 'ngx-scrollbar';
import { TruncatePipe } from '../_pipes/truncate-pipe';

import { FormAssistanceComponent } from '../project/settings/form-assistance/form-assistance.component';
import { FormDetailsComponent } from '../project/settings/form-assistance/form-details/form-details.component'; 
import { CkeditorComponent } from '../_directives/ckeditor/ckeditor.component';

import { TourSearchComponent } from './tour-search/tour-search.component';
import { AngularDraggableModule } from 'angular2-draggable';
import { CiraHelpComponent } from './cira-help/cira-help.component';
import { InfoIconComponent } from '../_directives/info-icon/info-icon.component';
import { DataChangeTrackingDirective } from '../_directives/data-change-tracking/data-change-tracking.directive';
import { ChatlogAnnotatorComponent } from '../project/training/components/re-training/chatlog-annotator/chatlog-annotator.component';
import { ChatAnswersComponent } from '../project/training/components/re-training/chat-answers/chat-answers.component';

import { ArticleNamePipe } from '../_pipes/article-name.pipe';
import { MentionModule } from 'fvi-angular-mentions/mention';
import { ProgressBarComponent } from '../_directives/long-progress/progress-bar/progress-bar.component';
import { LongProgressComponent } from '../_directives/long-progress/long-progress.component';
import { NotificationComponent } from '../_directives/notification/notification.component';
import { DownloadDirective } from '../_directives/download/download.directive';
import { ClickOutsideModule } from 'ng-click-outside';
import { TimelineFilterComponent } from '../_directives/timeline-filter/timeline-filter.component';
import { ActionNamePipe } from '../_pipes/action-name.pipe';

import { IconLibraryComponent } from './icon-library/icon-library.component';
import { ChatEditorComponent } from '../project/training/components/re-training/chat-editor/chat-editor.component';
import { ChatPreviewComponent } from './chat-preview/chat-preview.component';
import { TrainingTimePipe } from '../_pipes/training-time.pipe';
import { KnowledgePopupComponent } from './knowledge-popup/knowledge-popup.component';
import { FeatureMapperComponent } from '../project/training/components/re-training/feature-mapper/feature-mapper.component';
import { RemovePTagsPipe } from '../_pipes/remove-ptags.pipe';
import { MaterialModule } from './material-module';
import { ChatPreviewIframeComponent } from './chat-preview-iframe/chat-preview-iframe.component';
@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    PdfViewerModule,
     FormsModule,
     NgbModule,
    ScrollbarModule,
    CKEditorModule,
    AngularDraggableModule,
    ClipboardModule,
    MentionModule,
    ClickOutsideModule,
    MaterialModule
  ],

  declarations: [
     FormValidationMessageComponent,
     PaginationComponent,
     SearchByPipe,
     SortByPipe,
     KeysPipe,
     RoundPipe,
     TruncatePipe,
     PasswordValidator,
     TextSelectDirective,
     TimeAgoPipe,
     DragAndDropDirective,
     FormAssistanceComponent,
     FormDetailsComponent,
     SafehtmlPipe,
     NotificationsComponent,
     CkeditorComponent,
     TourSearchComponent,
     CiraHelpComponent,
     InfoIconComponent,
     DataChangeTrackingDirective,
     ChatEditorComponent,
     ChatlogAnnotatorComponent,
     ChatAnswersComponent,
     ChatPreviewComponent,
     TrainingTimePipe,
     KnowledgePopupComponent,
     ArticleNamePipe,
     ProgressBarComponent,
     LongProgressComponent,
     NotificationComponent,
     DownloadDirective,
     IconLibraryComponent,
     TimelineFilterComponent,
     ActionNamePipe,
     FeatureMapperComponent,
     RemovePTagsPipe,
     ChatPreviewIframeComponent
   ],

  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FormValidationMessageComponent,
    PaginationComponent,
    SearchByPipe,
    RoundPipe,
    SortByPipe,
    KeysPipe,
    TruncatePipe,
    PasswordValidator,
    TextSelectDirective,
    TimeAgoPipe,
    DragAndDropDirective,
    FormAssistanceComponent,
    FormDetailsComponent,
    SafehtmlPipe,
    NotificationsComponent,
    CkeditorComponent,
    CKEditorModule,
    TourSearchComponent,
    CiraHelpComponent,
    InfoIconComponent,
    DataChangeTrackingDirective,
    ChatEditorComponent,
    ChatlogAnnotatorComponent,
    ChatAnswersComponent,
    ChatPreviewComponent,
    TrainingTimePipe,
    KnowledgePopupComponent,
    ArticleNamePipe,
    LongProgressComponent,
    DownloadDirective,
    ClickOutsideModule,
    IconLibraryComponent,
    TimelineFilterComponent,
    ActionNamePipe,
    FeatureMapperComponent,
    RemovePTagsPipe,
    ChatPreviewIframeComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
   ],
  entryComponents: [InfoIconComponent]
})
export class CommonsModule { }
